import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNDocumentReportDocument extends CNItem {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDocumentReportDocument';
    }

    public clone(): any {
        return new CNDocumentReportDocument();
    }
}
